import * as React from "react";
import HiberSlider from "../../../hiberUiKit/src/atoms/Slider/HiberSlider";
import {none, option} from "ts-option";
import Amount from "../../../model/common/Amount";

interface ComponentProps {
	/**
	 * Quote total price
	 */
	startValue: Amount;
	/**
	 * Quote total price when labour cost is 0
	 */
	min: Amount;
	/**
	 * Quote total price when labour cost is 10000
	 */
	max: Amount;
	/**
	 * On change callback
	 * @param value
	 */
	onChanged: (value: number) => void
}

interface State {
	/**
	 * Initial value
	 */
	startValue: number;
	/**
	 * Slider minimum value (taking step into account)
	 */
	min: number;
	/**
	 * Slider maximum value (taking step into account)
	 */
	max: number;
	/**
	 * Slider step
	 */
	step: number;
}

export default class PriceAdjustSlider extends React.Component<ComponentProps, State> {

	constructor(props: ComponentProps) {
		super(props);
		const step = 5;
		const startVal = props.startValue.cents / 100;
		const min = Math.ceil(props.min.cents / 100 / step) * step;
		const max = Math.ceil(props.max.cents / 100 / step) * step;
		this.state = {
			startValue: startVal,
			min: min,
			max: max,
			step: step
		}
	}

	onSliderChange = (value: number) => {
		this.props.onChanged(value);
	};

	render() {
		return (
			<HiberSlider width={option(1150)}
						 title={option("Labour costs")}
						 className={none}
						 startValue={option(this.state.startValue)}
						 min={this.state.min}
						 max={this.state.max}
						 step={this.state.step}
						 onChanged={this.onSliderChange}/>
		)
	}

}
